<template>
  <div ref="myRef" :style="{ width: '100%', height: '100%' }"></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  props: {
    option: Object
  },
  data() {
    return {
      myRef: null
    };
  },
  mounted() {
    // setTimeout(() => {
    //   this.drawChart();
    // }, 20);
    console.log(this.option);
  },
  methods: {
    // 绘制折线图
    drawChart() {
      // 初始化echarts实例
      const Chart = echarts.init(this.$refs.myRef);
      // 父组件传来的实例参数
      this.$nextTick(() => {
        Chart.setOption(this.option);
      });
      window.addEventListener("resize", () => {
        // 页面大小变化后Echarts也更改大小
        Chart.resize();
      });
    }
  }
};
</script>
